import { render } from "./InterestsPage.vue?vue&type=template&id=4442a007&scoped=true"
import script from "./InterestsPage.vue?vue&type=script&lang=js"
export * from "./InterestsPage.vue?vue&type=script&lang=js"

import "./InterestsPage.vue?vue&type=style&index=0&id=4442a007&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4442a007"]])

export default __exports__